import { useEffect, useRef, useState } from 'react';
import API from './axios'; // Import your API instance
import { SkeletonAnnouncement, staggerStyle } from '../components/Skeleton';
import RadarLoader, { shouldShowRadar } from '../components/RadarLoader';
import useMinimumDuration from '../hooks/useMinimumDuration';
import '../styles/DiscordMessages.css'; // Import your styles

const Announcements = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  // Decided once on mount so the loader cannot swap mid-fetch.
  const useRadar = useRef(shouldShowRadar());
  // Only the branded loader is held open; plain skeletons can come and go
  // freely because they occupy the same box the content will.
  const holdRadar = useMinimumDuration(loading && useRadar.current);

  useEffect(() => {
    API.get('/announcements') // Adjust the endpoint as needed
      .then(res => setMessages(res.data.messages))
      .catch(err => console.error('Error fetching messages:', err))
      .finally(() => setLoading(false));
  }, []); // Empty dependency array ensures this runs only once on page load
// Function to parse Discord formatting
  const parseMessageContent = (content) => {
    content = content.replace(
    /^## (.*? \u003C:ISN:1127728654064033912\u003E)/,
    '<h2>$1</h2>'
  );
  // Replace lines starting with "## " and ending with nothing (no emoji)
  content = content.replace(/^## (.+)$/gm, '<h2>$1</h2>');
  content = content.replace(
    /^# (.*? \u003C:ISN:1127728654064033912\u003E)/,
    '<h3>$1</h3>'
  );
  content = content.replace(
    /@everyone/g, ' '

  );
  // Replace bold (**text**) with <strong>
  content = content.replace(
    /\*\*(.*?)\*\*/g, '<strong>$1</strong>'
  );
  // Replace italic (*text*) with <em>
  content = content.replace(
    /\*(.*?)\*/g, '<em>$1</em>'
  );
  // Replace \n\n with <br />
  content = content.replace(
    /\n/g, '<br />'

  );
  // Replace underline (__text__) with <u>
  content = content.replace(
    /__(.*?)__/g, '<u>$1</u>'

  );
  // Replace mentions (<@user_id>) with @username (you can customize this further)
  content = content.replace(
    /<@(\d+)>/g, '@User'

  );
  // Replace custom emojis (:emoji_name:) with a placeholder (you can customize this further)

  // Replace links (http://example.com) with clickable links
  content = content.replace(
    /(https?:\/\/[^\s]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
  );
  // Replace emoji IDs with actual emojis
  content = content.replace(
    /<a?:(\w+):(\d+)>/g, (match, name, id) => {
    return `<img src="https://cdn.discordapp.com/emojis/${id}.png" alt="${name}" />`;
  });
  // Replace specific ISN emoji with the logo
  content = content.replace(
    /\u003C:ISN:1127728654064033912\u003E/g,
    '<img src="logo.svg" alt="ISN Logo" style="width: 30px; height: 30px;" />'
    );
    content = content.replace(
    /\u003Ca:Radar:1135336528969728120\u003E/g,
    '<img src= "../imgs/radar.webp" class="discord-emoji" "alt="radar" style="width: 30px; height: 30px;" />'
     );

    content = content.replace(
    /\u003C:First:1135647887842361404\u003E/g,
    '<img src="../imgs/dragonball1.webp" alt="db1" style="width: 30px; height: 30px;" />'
     );

    content = content.replace(
    /\u003C:Second:1135647885430628444\u003E/g,
    '<img src="../imgs/dragonball2.webp" alt="db2" style="width: 30px; height: 30px;" />'
  );
  content = content.replace(
    /\u003C:Zeni:1135343075384885358\u003E/g,
    '<img src="../imgs/zeni.webp" alt="ISN Logo" style="width: 30px; height: 30px;" />'
  );

  content = content.replace(
  /\u003C#1100818902222647441\u003E/g,
    'the discord'
  );


  return content;
};

  if (loading || holdRadar) {
    return (
      <div className="discord-messages">
        <h1>Latest Announcements From Discord</h1>
        {useRadar.current ? (
          <RadarLoader />
        ) : (
          Array.from({ length: 3 }, (_, i) => <SkeletonAnnouncement key={i} />)
        )}
      </div>
    );
  }

  return (
    <div className="discord-messages">
      <h1>Latest Announcements From Discord</h1>
      <ul>
        {messages.map((msg, i) => (
          <li
            key={msg.id}
            className="discord-message stagger-item"
            style={staggerStyle(i)}
          >
            <div className="message-header">
              <h2 className="author">ISN Network</h2>
              <h3 className="timestamp">
                {new Date(msg.timestamp).toLocaleString()}
              </h3>
            </div>
            <div
              className="message-content"
              dangerouslySetInnerHTML={{ __html: parseMessageContent(msg.content) }}
            ></div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Announcements;


